import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

// ── Closer — Minha Semana ────────────────────────────────────────────────────
// A rotina-modelo (só o Vagner edita) vira blocos executáveis a cada semana
// (gerados automaticamente na sexta). O closer abre a página, vê o bloco de
// AGORA em destaque e vai dando desfecho: ✓ feito (com o que foi feito) ou
// ✗ não realizado (com motivo). Formato enxuto de lista, igual à Agenda.

function token() { return localStorage.getItem('token'); }
function ehVagner() {
  try {
    const t = token();
    if (!t) return false;
    // JWT usa base64url: normaliza antes do atob (senão '-'/'_' quebram a decodificação)
    return JSON.parse(atob(t.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).email === 'vagnerfreittas@gmail.com';
  } catch { return false; }
}

async function apiJson(url, opts = {}) {
  const res = await fetch(url, {
    ...opts,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}`, ...(opts.headers || {}) },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.erro || 'Erro');
  return data;
}

// Tipos de atividade: ícone + atalho pra ferramenta onde ela acontece.
// followup/parceiros/radar têm FILA: o bloco abre com os contatos separados.
export const TIPOS_CLOSER = [
  { key: 'followup',   icone: '📞', rotulo: 'Follow-up',          link: '/crm',             dica: 'Abrir o CRM' },
  { key: 'prospeccao', icone: '🎯', rotulo: 'Prospecção',          link: '/sdr',             dica: 'Abrir o SDR' },
  { key: 'radar',      icone: '📡', rotulo: 'Radar RPI',           link: '/sdr',             dica: 'Abrir o SDR (Radar)' },
  { key: 'parceiros',  icone: '🤝', rotulo: 'Parceiros',           link: '/parceiros',       dica: 'Abrir Parceiros' },
  { key: 'proposta',   icone: '📄', rotulo: 'Propostas',           link: '/crm',             dica: 'Abrir o CRM' },
  { key: 'reuniao',    icone: '🗓️', rotulo: 'Reunião',             link: '',                 dica: '' },
  { key: 'sucesso',    icone: '💚', rotulo: 'Sucesso do Cliente',  link: '/sucesso-cliente', dica: 'Abrir Sucesso do Cliente' },
  { key: 'outro',      icone: '🧩', rotulo: 'Outro',               link: '',                 dica: '' },
];

// Gatilhos do Radar (pro bloco tipo Radar já nascer apontando pra lista certa)
export const GATILHOS_RADAR = [
  ['', '(qualquer lista do Radar)'],
  ['sozinhos', 'Depositaram sozinhos'], ['exigencia', 'Exigência com prazo'],
  ['indeferido', 'Pedido indeferido'], ['oposicao', 'Sofreram oposição'],
  ['deferido', 'Deferidos — pagar concessão'], ['expirado', 'Marca expirada / caducando'],
  ['perdido', 'Pedido perdido'],
];
const TIPOS_PARCEIRO_FILA = [['', 'Todos os tipos'], ['Contador', 'Contadores'], ['Designer', 'Designers'], ['Consultor', 'Consultores']];

// Campos de fila do formulário de bloco (rotina e semana)
function CamposFila({ form, setForm }) {
  if (form.tipo === 'radar') return (
    <div style={{ minWidth: 150, flex: '1 1 150px' }}>
      <label style={lbl}>Gatilho da fila</label>
      <select value={form.fila_gatilho || ''} onChange={e => setForm(f => ({ ...f, fila_gatilho: e.target.value }))} style={inp}>
        {GATILHOS_RADAR.map(([v, r]) => <option key={v} value={v}>{r}</option>)}
      </select>
    </div>
  );
  if (form.tipo === 'parceiros') return (
    <div style={{ minWidth: 130, flex: '1 1 130px' }}>
      <label style={lbl}>Parceiros da fila</label>
      <select value={form.fila_parceiro_tipo || ''} onChange={e => setForm(f => ({ ...f, fila_parceiro_tipo: e.target.value }))} style={inp}>
        {TIPOS_PARCEIRO_FILA.map(([v, r]) => <option key={v} value={v}>{r}</option>)}
      </select>
    </div>
  );
  if (form.tipo === 'prospeccao') return (
    <>
      <div style={{ minWidth: 140, flex: '1 1 140px' }}>
        <label style={lbl} title="O ▶ abre a lista mais recente do SDR cujo nome contém essa palavra (ex.: listagens compradas subidas na sexta)">Palavra-chave da lista</label>
        <input value={form.fila_lista_busca || ''} onChange={e => setForm(f => ({ ...f, fila_lista_busca: e.target.value }))}
          placeholder="Ex.: contador" style={inp} />
      </div>
      <div style={{ minWidth: 200, flex: '2 1 200px' }}>
        <label style={lbl} title="Porta a porta virtual: o ▶ gera a lista do território direto do Google (com telefone), sem quem já está na base">🗺️ Território PAP (Google)</label>
        <input value={form.fila_maps || ''} onChange={e => setForm(f => ({ ...f, fila_maps: e.target.value }))}
          placeholder="Ex.: restaurantes @ Catolé, Campina Grande - PB" style={inp} />
      </div>
    </>
  );
  return null;
}
const tipoDe = (key) => TIPOS_CLOSER.find(t => t.key === key) || TIPOS_CLOSER[TIPOS_CLOSER.length - 1];

// ── Datas (fuso Paraíba, UTC−3) ──
const BRT_MS = 3 * 3600000;
const hojeBrt = () => new Date(Date.now() - BRT_MS).toISOString().slice(0, 10);
const horaBrt = () => new Date(Date.now() - BRT_MS).toISOString().slice(11, 16);
const diaSemanaDe = (iso) => new Date(iso + 'T12:00:00Z').getUTCDay();
const somarDias = (iso, n) => { const d = new Date(iso + 'T12:00:00Z'); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };
const segundaDe = (iso) => somarDias(iso, -((diaSemanaDe(iso) + 6) % 7));
const fmtCurto = (iso) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;
const NOMES_DIA = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

// Estilos no padrão enxuto da Agenda
const inp = { width: '100%', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', boxSizing: 'border-box', background: '#fff', height: 26 };
const lbl = { fontSize: 11, fontWeight: 600, color: '#6b7280', display: 'block', marginBottom: 2 };
const modalBase = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 };

function BtnPrimary({ children, ...props }) {
  return (
    <button {...props} style={{ background: '#0a1628', color: '#fff', padding: '4px 14px', fontSize: 12, fontWeight: 600, borderRadius: 4, border: 'none', cursor: 'pointer', ...(props.style || {}) }}>
      {children}
    </button>
  );
}
function BtnCancel({ children, ...props }) {
  return (
    <button {...props} style={{ background: '#f3f4f6', color: '#374151', padding: '4px 12px', fontSize: 12, borderRadius: 4, border: '1px solid #d1d5db', cursor: 'pointer', ...(props.style || {}) }}>
      {children}
    </button>
  );
}

// Situação do bloco (chips iguais aos da Agenda; cores casam com o Analitics)
function situacaoBloco(b, hoje, agoraHM) {
  if (b.status === 'feito') return { key: 'feito', rotulo: 'Feito', cor: '#16a34a', bg: '#f0fdf4' };
  if (b.status === 'nao_feito') return { key: 'nao_feito', rotulo: 'Não feito', cor: '#dc2626', bg: '#fef2f2' };
  if (b.data < hoje || (b.data === hoje && b.hora_fim <= agoraHM)) return { key: 'vencido', rotulo: 'Venceu', cor: '#b45309', bg: '#fffbeb' };
  if (b.data === hoje && b.hora_ini <= agoraHM && agoraHM < b.hora_fim) return { key: 'agora', rotulo: '▶ Agora', cor: '#1d4ed8', bg: '#eff6ff' };
  return { key: 'pendente', rotulo: 'Pendente', cor: '#d97706', bg: '#fffbeb' };
}

// ── Modal: concluir bloco (✓ com "o que foi feito") ──
function ModalConcluir({ bloco, onFechar, onSalvo }) {
  const [resultado, setResultado] = useState('');
  const [salvando, setSalvando] = useState(false);
  async function salvar() {
    setSalvando(true);
    try {
      await apiJson(`/closer/bloco/${bloco._id}/concluir`, { method: 'PUT', body: JSON.stringify({ resultado }) });
      onSalvo();
    } catch (e) { window.alert(e.message); setSalvando(false); }
  }
  return (
    <div style={modalBase} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 6, width: 440, maxWidth: '95vw', border: '1px solid #c8d0da' }}>
        <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '6px 6px 0 0' }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>✓ Concluir bloco</span>
        </div>
        <div style={{ padding: '10px 14px' }}>
          <div style={{ fontSize: 12, color: '#374151', background: '#f9fafb', padding: '6px 8px', borderRadius: 3, marginBottom: 10, border: '1px solid #e5e7eb' }}>
            {NOMES_DIA[bloco.dia_semana]} · {bloco.hora_ini}–{bloco.hora_fim} — {bloco.atividade}
          </div>
          <label style={lbl}>O que foi feito? (aparece no Closer Analitics)</label>
          <textarea value={resultado} onChange={e => setResultado(e.target.value)} rows={3} autoFocus
            placeholder="Ex.: 14 follow-ups, 2 propostas enviadas, 1 reunião marcada…"
            style={{ width: '100%', resize: 'vertical', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box', marginBottom: 10 }} />
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={salvar} disabled={salvando}
              style={{ background: '#16a34a', color: '#fff', padding: '5px 16px', borderRadius: 4, fontSize: 13, fontWeight: 600, border: 'none', cursor: 'pointer', opacity: salvando ? 0.6 : 1 }}>
              {salvando ? 'Salvando...' : '✓ Confirmar Feito'}
            </button>
            <BtnCancel onClick={onFechar}>Cancelar</BtnCancel>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Modal: não realizado (✗ com motivo) ──
function ModalNaoRealizado({ bloco, onFechar, onSalvo }) {
  const [motivo, setMotivo] = useState('');
  const [salvando, setSalvando] = useState(false);
  async function salvar() {
    setSalvando(true);
    try {
      await apiJson(`/closer/bloco/${bloco._id}/nao-realizado`, { method: 'PUT', body: JSON.stringify({ motivo }) });
      onSalvo();
    } catch (e) { window.alert(e.message); setSalvando(false); }
  }
  return (
    <div style={modalBase} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 6, width: 440, maxWidth: '95vw', border: '1px solid #c8d0da' }}>
        <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '6px 6px 0 0' }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>✗ Não realizado</span>
        </div>
        <div style={{ padding: '10px 14px' }}>
          <div style={{ fontSize: 12, color: '#374151', background: '#f9fafb', padding: '6px 8px', borderRadius: 3, marginBottom: 10, border: '1px solid #e5e7eb' }}>
            {NOMES_DIA[bloco.dia_semana]} · {bloco.hora_ini}–{bloco.hora_fim} — {bloco.atividade}
          </div>
          <label style={lbl}>Por quê?</label>
          <textarea value={motivo} onChange={e => setMotivo(e.target.value)} rows={2} autoFocus
            placeholder="Ex.: reunião com cliente atravessou o horário…"
            style={{ width: '100%', resize: 'vertical', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box', marginBottom: 10 }} />
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={salvar} disabled={salvando}
              style={{ background: '#dc2626', color: '#fff', padding: '5px 16px', borderRadius: 4, fontSize: 13, fontWeight: 600, border: 'none', cursor: 'pointer', opacity: salvando ? 0.6 : 1 }}>
              {salvando ? 'Salvando...' : '✗ Marcar não realizado'}
            </button>
            <BtnCancel onClick={onFechar}>Cancelar</BtnCancel>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Modal: rotina padrão (CRUD — só Vagner) ──
function ModalRotina({ onFechar }) {
  const [rotina, setRotina] = useState([]);
  const [form, setForm] = useState({ dia_semana: '1', hora_ini: '08:00', hora_fim: '10:00', atividade: '', tipo: 'followup', fila_gatilho: '', fila_parceiro_tipo: '', fila_lista_busca: '', fila_maps: '' });
  const [editando, setEditando] = useState(null); // _id em edição
  const [erro, setErro] = useState('');

  // Vários modelos de semana; um é o automático de sexta (★)
  const [infoModelos, setInfoModelos] = useState({ ativo: 'Padrão', modelos: ['Padrão'] });
  const [modeloSel, setModeloSel] = useState('');

  const carregar = useCallback(() => {
    apiJson('/closer/rotina/modelos').then(m => {
      setInfoModelos(m);
      setModeloSel(sel => sel || m.ativo);
    }).catch(() => {});
    if (modeloSel) apiJson(`/closer/rotina?modelo=${encodeURIComponent(modeloSel)}`).then(setRotina).catch(() => {});
  }, [modeloSel]);
  useEffect(() => { carregar(); }, [carregar]);

  async function salvar() {
    setErro('');
    try {
      const body = JSON.stringify({ ...form, modelo: modeloSel });
      if (editando) await apiJson(`/closer/rotina/${editando}`, { method: 'PUT', body });
      else await apiJson('/closer/rotina', { method: 'POST', body });
      setForm(f => ({ ...f, atividade: '' }));
      setEditando(null);
      carregar();
    } catch (e) { setErro(e.message); }
  }

  async function novoModelo() {
    const nome = window.prompt('Nome do novo modelo de semana (ex.: Semana de mutirão):', '');
    if (!nome || !nome.trim()) return;
    const duplicar = window.confirm(`Começar o "${nome.trim()}" como CÓPIA do modelo "${modeloSel}"?\n\nOK = copiar os blocos · Cancelar = começar vazio`);
    try {
      await apiJson('/closer/rotina/modelos', { method: 'POST', body: JSON.stringify({ nome: nome.trim(), duplicar_de: duplicar ? modeloSel : '' }) });
      setModeloSel(nome.trim());
    } catch (e) { window.alert(e.message); }
  }

  async function definirAutomatico() {
    try {
      await apiJson('/closer/rotina/modelos/ativo', { method: 'PUT', body: JSON.stringify({ nome: modeloSel }) });
      carregar();
    } catch (e) { window.alert(e.message); }
  }

  async function excluirModelo() {
    if (!window.confirm(`Excluir o modelo "${modeloSel}" e todos os blocos dele? (semanas já geradas não mudam)`)) return;
    try {
      await apiJson(`/closer/rotina/modelos/${encodeURIComponent(modeloSel)}`, { method: 'DELETE' });
      setModeloSel(infoModelos.ativo);
    } catch (e) { window.alert(e.message); }
  }
  async function excluir(id) {
    if (!window.confirm('Remover este bloco do padrão? (semanas já geradas não mudam)')) return;
    try { await apiJson(`/closer/rotina/${id}`, { method: 'DELETE' }); carregar(); } catch (e) { window.alert(e.message); }
  }

  const porDia = {};
  rotina.forEach(b => { (porDia[b.dia_semana] = porDia[b.dia_semana] || []).push(b); });
  // Quadro tipo calendário: seg–sex sempre; sáb/dom só se tiverem bloco
  const diasQuadro = [1, 2, 3, 4, 5, ...[6, 0].filter(d => porDia[d]?.length)];
  const COR_TIPO = { followup: '#1d4ed8', prospeccao: '#b91c1c', radar: '#7c3aed', parceiros: '#b45309', proposta: '#0e7490', reuniao: '#374151', sucesso: '#16a34a', outro: '#6b7280' };
  const rotuloGatilho = (k) => (GATILHOS_RADAR.find(([v]) => v === k) || ['', ''])[1];
  const editarBloco = (b) => {
    setEditando(b._id);
    setForm({ dia_semana: String(b.dia_semana), hora_ini: b.hora_ini, hora_fim: b.hora_fim, atividade: b.atividade, tipo: b.tipo || 'outro', fila_gatilho: b.fila_gatilho || '', fila_parceiro_tipo: b.fila_parceiro_tipo || '', fila_lista_busca: b.fila_lista_busca || '', fila_maps: b.fila_maps || '' });
  };

  return (
    <div style={modalBase} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 6, width: 980, maxWidth: '96%', maxHeight: '90vh', overflowY: 'auto', border: '1px solid #c8d0da' }}>
        <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '6px 6px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ color: '#fff', fontWeight: 700, fontSize: 14 }}>✏️ Rotina padrão da semana</span>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
        <div style={{ padding: '10px 14px' }}>
          <p style={{ fontSize: 12, color: '#6b7280', margin: '0 0 8px' }}>
            Monte quantos <strong>modelos de semana</strong> quiser. O modelo com ★ é o que a geração automática de sexta usa;
            na geração manual você escolhe qualquer um. A semana já montada você ajusta direto na tela.
          </p>

          {/* Barra de modelos */}
          <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap', marginBottom: 8 }}>
            <span style={{ fontSize: 11, fontWeight: 600, color: '#6b7280' }}>Modelo:</span>
            <select value={modeloSel} onChange={e => { setModeloSel(e.target.value); setEditando(null); }} style={{ ...inp, width: 'auto', minWidth: 170, fontWeight: 700 }}>
              {infoModelos.modelos.map(m => <option key={m} value={m}>{m === infoModelos.ativo ? `★ ${m}` : m}</option>)}
            </select>
            {modeloSel === infoModelos.ativo ? (
              <span style={{ fontSize: 11, fontWeight: 700, color: '#b45309', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 10, padding: '1px 8px' }}>★ automático de sexta</span>
            ) : (
              <button onClick={definirAutomatico} style={{ fontSize: 11, fontWeight: 600, background: '#fff', color: '#b45309', border: '1px solid #fde68a', borderRadius: 4, padding: '2px 8px', cursor: 'pointer' }}>
                ★ Usar na geração automática
              </button>
            )}
            <button onClick={novoModelo} style={{ fontSize: 11, fontWeight: 600, background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 4, padding: '2px 8px', cursor: 'pointer' }}>
              ➕ Novo modelo
            </button>
            {modeloSel !== infoModelos.ativo && (
              <button onClick={excluirModelo} style={{ fontSize: 11, fontWeight: 600, background: '#fff', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 4, padding: '2px 8px', cursor: 'pointer' }}>
                🗑 Excluir modelo
              </button>
            )}
          </div>

          {/* Quem segue qual modelo (closer sem atribuição segue o ★ global) */}
          {(infoModelos.closers || []).length > 0 && (
            <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', marginBottom: 8, background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 4, padding: '5px 8px' }}>
              <span style={{ fontSize: 11, fontWeight: 700, color: '#0a1628' }}>Modelo de cada closer:</span>
              {(infoModelos.closers || []).map(c => (
                <span key={c} style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                  <span style={{ fontSize: 11.5, fontWeight: 600, color: '#374151' }}>{c.split(' ')[0]}:</span>
                  <select value={(infoModelos.por_closer || {})[c] || ''}
                    onChange={async e => {
                      try {
                        await apiJson('/closer/rotina/modelos/atribuir', { method: 'PUT', body: JSON.stringify({ closer: c, modelo: e.target.value }) });
                        carregar();
                      } catch (err) { window.alert(err.message); }
                    }}
                    style={{ ...inp, width: 'auto', minWidth: 150, height: 24, fontSize: 11.5 }}>
                    <option value="">★ global ({infoModelos.ativo})</option>
                    {infoModelos.modelos.map(m => <option key={m} value={m}>{m}</option>)}
                  </select>
                </span>
              ))}
            </div>
          )}

          {/* Formulário adicionar/editar */}
          <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 4, padding: 8, marginBottom: 10 }}>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'flex-end' }}>
              <div style={{ minWidth: 100, flex: '1 1 100px' }}>
                <label style={lbl}>Dia</label>
                <select value={form.dia_semana} onChange={e => setForm(f => ({ ...f, dia_semana: e.target.value }))} style={inp}>
                  {[1, 2, 3, 4, 5, 6, 0].map(d => <option key={d} value={d}>{NOMES_DIA[d]}</option>)}
                </select>
              </div>
              <div style={{ width: 86 }}>
                <label style={lbl}>Início</label>
                <input type="time" value={form.hora_ini} onChange={e => setForm(f => ({ ...f, hora_ini: e.target.value }))} style={inp} />
              </div>
              <div style={{ width: 86 }}>
                <label style={lbl}>Fim</label>
                <input type="time" value={form.hora_fim} onChange={e => setForm(f => ({ ...f, hora_fim: e.target.value }))} style={inp} />
              </div>
              <div style={{ minWidth: 140, flex: '2 1 160px' }}>
                <label style={lbl}>Atividade</label>
                <input value={form.atividade} onChange={e => setForm(f => ({ ...f, atividade: e.target.value }))}
                  placeholder="Ex.: Radar RPI — exigência de mérito" style={inp} />
              </div>
              <div style={{ minWidth: 120, flex: '1 1 120px' }}>
                <label style={lbl}>Tipo (atalho)</label>
                <select value={form.tipo} onChange={e => setForm(f => ({ ...f, tipo: e.target.value }))} style={inp}>
                  {TIPOS_CLOSER.map(t => <option key={t.key} value={t.key}>{t.icone} {t.rotulo}</option>)}
                </select>
              </div>
              <CamposFila form={form} setForm={setForm} />
              <BtnPrimary onClick={salvar} style={{ height: 26, padding: '0 12px' }}>{editando ? 'Salvar' : '+ Adicionar'}</BtnPrimary>
              {editando && <BtnCancel onClick={() => { setEditando(null); setForm(f => ({ ...f, atividade: '' })); }} style={{ height: 26, padding: '0 10px' }}>Cancelar</BtnCancel>}
            </div>
            {erro && <div style={{ color: '#dc2626', fontSize: 12, marginTop: 6 }}>{erro}</div>}
          </div>

          {/* Quadro semanal (colunas por dia, estilo calendário) */}
          {rotina.length === 0 ? (
            <div style={{ textAlign: 'center', color: '#9ca3af', fontSize: 13, padding: 14 }}>
              Nenhum bloco ainda. Monte o padrão acima — ex.: Segunda 08:00–10:00 Follow-up.
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: `repeat(${diasQuadro.length}, 1fr)`, gap: 6, alignItems: 'start' }}>
              {diasQuadro.map(d => (
                <div key={d}>
                  <div style={{ background: '#0a1628', color: '#fff', borderRadius: '4px 4px 0 0', padding: '3px 8px', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>{NOMES_DIA[d].slice(0, 3)}</span>
                    <button onClick={() => { setEditando(null); setForm(f => ({ ...f, dia_semana: String(d) })); }}
                      title={`Adicionar bloco na ${NOMES_DIA[d]}`}
                      style={{ background: 'rgba(255,255,255,0.15)', color: '#fff', border: 'none', borderRadius: 3, width: 16, height: 16, fontSize: 12, lineHeight: '14px', cursor: 'pointer', padding: 0 }}>+</button>
                  </div>
                  <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderTop: 'none', borderRadius: '0 0 4px 4px', padding: 4, minHeight: 140, display: 'flex', flexDirection: 'column', gap: 4 }}>
                    {(porDia[d] || []).slice().sort((a, b) => (a.hora_ini || '').localeCompare(b.hora_ini || '')).map(b => (
                      <div key={b._id} onClick={() => editarBloco(b)} title="Clique para editar"
                        style={{
                          background: editando === b._id ? '#eff6ff' : '#fff',
                          border: `1px solid ${editando === b._id ? '#93c5fd' : '#e5e7eb'}`,
                          borderTop: `3px solid ${COR_TIPO[b.tipo] || COR_TIPO.outro}`,
                          borderRadius: 4, padding: '4px 6px', cursor: 'pointer', position: 'relative',
                        }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <span style={{ fontSize: 10.5, fontWeight: 800, color: '#0a1628' }}>{b.hora_ini}–{b.hora_fim}</span>
                          <button onClick={e => { e.stopPropagation(); excluir(b._id); }} title="Remover do padrão"
                            style={{ background: 'none', color: '#dc2626', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 700, padding: 0, lineHeight: 1 }}>✕</button>
                        </div>
                        <div style={{ fontSize: 11.5, color: '#111', lineHeight: 1.25, marginTop: 1 }}>{tipoDe(b.tipo).icone} {b.atividade}</div>
                        {b.tipo === 'radar' && b.fila_gatilho && (
                          <div style={{ fontSize: 9.5, color: '#7c3aed', fontWeight: 700, marginTop: 2 }}>🎯 {rotuloGatilho(b.fila_gatilho)}</div>
                        )}
                        {b.tipo === 'parceiros' && (
                          <div style={{ fontSize: 9.5, color: '#b45309', fontWeight: 700, marginTop: 2 }}>🤝 {(TIPOS_PARCEIRO_FILA.find(([v]) => v === (b.fila_parceiro_tipo || '')) || ['', 'Todos os tipos'])[1]}</div>
                        )}
                        {b.tipo === 'prospeccao' && b.fila_lista_busca && (
                          <div style={{ fontSize: 9.5, color: '#b91c1c', fontWeight: 700, marginTop: 2 }}>📋 lista: {b.fila_lista_busca}</div>
                        )}
                        {b.tipo === 'prospeccao' && b.fila_maps && (
                          <div style={{ fontSize: 9.5, color: '#0e7490', fontWeight: 700, marginTop: 2 }}>🗺️ {b.fila_maps}</div>
                        )}
                      </div>
                    ))}
                    {(porDia[d] || []).length === 0 && (
                      <div style={{ fontSize: 10.5, color: '#c8d0da', textAlign: 'center', paddingTop: 12 }}>— livre —</div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ── Modal: bloco avulso / editar bloco da semana (só Vagner) ──
function ModalBloco({ bloco, semana, closers, closerPadrao, onFechar, onSalvo }) {
  const [form, setForm] = useState(bloco ? {
    data: bloco.data, hora_ini: bloco.hora_ini, hora_fim: bloco.hora_fim,
    atividade: bloco.atividade, tipo: bloco.tipo || 'outro', closer: bloco.closer,
    fila_gatilho: bloco.fila_gatilho || '', fila_parceiro_tipo: bloco.fila_parceiro_tipo || '', fila_lista_busca: bloco.fila_lista_busca || '', fila_maps: bloco.fila_maps || '',
  } : {
    data: semana, hora_ini: '08:00', hora_fim: '10:00', atividade: '', tipo: 'followup', closer: closerPadrao || (closers[0] || ''),
    fila_gatilho: '', fila_parceiro_tipo: '', fila_lista_busca: '', fila_maps: '',
  });
  const [erro, setErro] = useState('');
  async function salvar() {
    setErro('');
    try {
      if (bloco) await apiJson(`/closer/bloco/${bloco._id}`, { method: 'PUT', body: JSON.stringify(form) });
      else await apiJson('/closer/bloco', { method: 'POST', body: JSON.stringify(form) });
      onSalvo();
    } catch (e) { setErro(e.message); }
  }
  return (
    <div style={modalBase} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 6, width: 440, maxWidth: '95vw', border: '1px solid #c8d0da' }}>
        <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '6px 6px 0 0' }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>{bloco ? '✏️ Editar bloco' : '➕ Bloco avulso na semana'}</span>
        </div>
        <div style={{ padding: '10px 14px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 86px 86px', gap: 6, marginBottom: 6 }}>
            <div>
              <label style={lbl}>Data</label>
              <input type="date" value={form.data} onChange={e => setForm(f => ({ ...f, data: e.target.value }))} style={inp} />
            </div>
            <div>
              <label style={lbl}>Início</label>
              <input type="time" value={form.hora_ini} onChange={e => setForm(f => ({ ...f, hora_ini: e.target.value }))} style={inp} />
            </div>
            <div>
              <label style={lbl}>Fim</label>
              <input type="time" value={form.hora_fim} onChange={e => setForm(f => ({ ...f, hora_fim: e.target.value }))} style={inp} />
            </div>
          </div>
          <label style={lbl}>Atividade</label>
          <input value={form.atividade} onChange={e => setForm(f => ({ ...f, atividade: e.target.value }))} placeholder="Ex.: Mutirão de propostas paradas" style={{ ...inp, marginBottom: 6 }} />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginBottom: 6 }}>
            <div>
              <label style={lbl}>Tipo (atalho)</label>
              <select value={form.tipo} onChange={e => setForm(f => ({ ...f, tipo: e.target.value }))} style={inp}>
                {TIPOS_CLOSER.map(t => <option key={t.key} value={t.key}>{t.icone} {t.rotulo}</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>Closer</label>
              <select value={form.closer} onChange={e => setForm(f => ({ ...f, closer: e.target.value }))} style={inp}>
                {closers.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
            <CamposFila form={form} setForm={setForm} />
          </div>
          {erro && <div style={{ color: '#dc2626', fontSize: 12, marginBottom: 8 }}>{erro}</div>}
          <div style={{ display: 'flex', gap: 8 }}>
            <BtnPrimary onClick={salvar}>{bloco ? 'Salvar' : 'Adicionar'}</BtnPrimary>
            <BtnCancel onClick={onFechar}>Cancelar</BtnCancel>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Modo trabalho: a fila do bloco, sem sair da tela ─────────
// Follow-up: tarefas das negociações (✓ conclui a tarefa na hora) e
// negociações sem próxima ação. Parceiros: quem está há mais tempo sem
// contato (✓ registra o contato no cadastro). Zero decisão, zero distração.
function ModalTrabalho({ bloco, onFechar, aoAbrirCrm }) {
  const [itens, setItens] = useState(null);
  const [feitos, setFeitos] = useState(0);
  const [copiado, setCopiado] = useState('');

  const carregar = useCallback(() => {
    const url = bloco.tipo === 'followup'
      ? `/closer/fila/followup?closer=${encodeURIComponent(bloco.closer)}`
      : `/closer/fila/parceiros?tipo=${encodeURIComponent(bloco.fila_parceiro_tipo || '')}`;
    apiJson(url).then(d => setItens(d.itens || [])).catch(() => setItens([]));
  }, [bloco]);
  useEffect(() => { carregar(); }, [carregar]);

  function copiar(tel) {
    const dig = (tel || '').replace(/\D/g, '');
    if (navigator.clipboard) navigator.clipboard.writeText(dig).catch(() => {});
    setCopiado(tel);
    setTimeout(() => setCopiado(''), 1200);
  }
  const waLink = (tel) => {
    const dig = (tel || '').replace(/\D/g, '');
    return dig ? `https://wa.me/${dig.length <= 11 ? '55' + dig : dig}` : '';
  };

  async function concluirTarefa(it) {
    const texto = window.prompt(`O que foi feito com ${it.nome || 'o contato'}?`, '');
    if (texto === null) return;
    try {
      await apiJson(`/agenda/${it.id}`, { method: 'PUT', body: JSON.stringify({
        descricao: it.descricao, data_agendada: it.data, destinado_a: bloco.closer,
        realizado: (texto || 'Contato realizado').trim(),
      }) });
      setFeitos(n => n + 1);
      setItens(list => list.filter(x => x.id !== it.id));
    } catch (e) { window.alert(e.message); }
  }

  async function contatoParceiro(it) {
    const nota = window.prompt(`O que rolou com ${it.nome}?`, '');
    if (nota === null) return;
    try {
      await apiJson(`/parceiros/${it.id}/contato`, { method: 'POST', body: JSON.stringify({ nota: (nota || '').trim() }) });
      setFeitos(n => n + 1);
      setItens(list => list.filter(x => x.id !== it.id));
    } catch (e) { window.alert(e.message); }
  }

  return (
    <div style={modalBase} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 6, width: 660, maxWidth: '96%', maxHeight: '90vh', display: 'flex', flexDirection: 'column', border: '1px solid #c8d0da', overflow: 'hidden' }}>
        <div style={{ background: '#0a1628', padding: '8px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <span style={{ color: '#fff', fontWeight: 700, fontSize: 14 }}>▶ {tipoDe(bloco.tipo).icone} {bloco.atividade}</span>
            <div style={{ fontSize: 11, color: '#94a3b8' }}>
              {bloco.hora_ini}–{bloco.hora_fim} · {itens ? `${itens.length} na fila` : 'carregando…'}{feitos ? ` · ✓ ${feitos} trabalhado(s) agora` : ''}
            </div>
          </div>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
        <div style={{ overflowY: 'auto', flex: 1 }}>
          {!itens ? (
            <div style={{ textAlign: 'center', color: '#6b7280', padding: 24, fontSize: 13 }}>Separando a fila…</div>
          ) : itens.length === 0 ? (
            <div style={{ textAlign: 'center', color: '#16a34a', padding: 24, fontSize: 13 }}>🎉 Fila zerada — nada esperando aqui.</div>
          ) : itens.map((it, i) => (
            <div key={it.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 14px', borderBottom: '1px solid #f3f4f6', background: i % 2 ? '#fafafa' : '#fff', flexWrap: 'wrap' }}>
              <div style={{ flex: 1, minWidth: 180 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>
                  {it.urgente && '🔴 '}{it.favorita && '⭐ '}{it.nome || '(sem nome)'}
                  {it.tipo === 'parceiro' && <span style={{ fontWeight: 400, color: '#6b7280', fontSize: 11 }}> · {it.parceiro_tipo}</span>}
                  {it.etapa && <span style={{ fontWeight: 400, color: '#6b7280', fontSize: 11 }}> · {it.etapa}</span>}
                </div>
                <div style={{ fontSize: 12, color: it.tipo === 'negociacao' ? '#b45309' : '#374151' }}>
                  {it.tipo === 'parceiro'
                    ? (it.dias_sem_contato == null ? '🆕 Nunca contatado' : `Último contato há ${it.dias_sem_contato} dia(s)`)
                    : it.descricao}
                </div>
                {it.data && <div style={{ fontSize: 11, color: it.atrasada ? '#dc2626' : '#9ca3af' }}>{it.atrasada ? '⏰ Atrasada — ' : ''}{it.data.slice(8, 10)}/{it.data.slice(5, 7)}{it.data.includes('T') ? ` ${it.data.slice(11, 16)}` : ''}</div>}
              </div>
              {it.telefone && (
                <span style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                  <span style={{ fontFamily: 'monospace', fontSize: 12, color: '#374151', whiteSpace: 'nowrap' }}>{it.telefone}</span>
                  <button onClick={() => copiar(it.telefone)} title="Copiar telefone"
                    style={{ background: copiado === it.telefone ? '#dcfce7' : '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 3, padding: '1px 6px', fontSize: 10.5, cursor: 'pointer' }}>
                    {copiado === it.telefone ? '✓' : '📋'}
                  </button>
                  <a href={waLink(it.telefone)} target="_blank" rel="noreferrer" title="Abrir WhatsApp"
                    style={{ background: '#dcfce7', color: '#15803d', border: '1px solid #bbf7d0', borderRadius: 3, padding: '1px 6px', fontSize: 10.5, textDecoration: 'none' }}>💬</a>
                </span>
              )}
              {it.tipo === 'tarefa' && (
                <button onClick={() => concluirTarefa(it)}
                  style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 3, padding: '3px 10px', fontSize: 11, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                  ✓ Feito
                </button>
              )}
              {it.tipo === 'parceiro' && (
                <button onClick={() => contatoParceiro(it)}
                  style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 3, padding: '3px 10px', fontSize: 11, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                  ✓ Contato feito
                </button>
              )}
              {it.tipo === 'negociacao' && (
                <button onClick={() => { onFechar(); aoAbrirCrm && aoAbrirCrm(); }}
                  style={{ background: '#fffbeb', color: '#b45309', border: '1px solid #fde68a', borderRadius: 3, padding: '3px 10px', fontSize: 11, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                  Agendar no CRM →
                </button>
              )}
            </div>
          ))}
        </div>
        <div style={{ borderTop: '1px solid #e8eaed', padding: '8px 14px', fontSize: 11.5, color: '#6b7280' }}>
          Terminou o horário? Feche aqui e dê o <strong>✓ Feito</strong> no bloco com o resumo do que saiu.
        </div>
      </div>
    </div>
  );
}

// ── Página ──
export default function Closer() {
  const navigate = useNavigate();
  const vagner = ehVagner();
  const nomeUsuario = localStorage.getItem('nomeUsuario') || '';

  const [semana, setSemana] = useState(() => segundaDe(hojeBrt()));
  const [dados, setDados] = useState(null);
  const [closerSel, setCloserSel] = useState('');
  const [modalRotina, setModalRotina] = useState(false);
  const [modalConcluir, setModalConcluir] = useState(null);
  const [modalNao, setModalNao] = useState(null);
  const [modalBloco, setModalBloco] = useState(null); // {bloco|null} — null = novo
  const [modalTrabalho, setModalTrabalho] = useState(null); // bloco em execução (fila)
  // Modelos de semana (geração manual escolhe; ★ = automático de sexta)
  const [infoModelos, setInfoModelos] = useState({ ativo: 'Padrão', modelos: ['Padrão'] });
  const [modeloGerar, setModeloGerar] = useState('');
  useEffect(() => {
    if (!ehVagner()) return;
    apiJson('/closer/rotina/modelos').then(setInfoModelos).catch(() => {});
  }, [modalRotina]);
  const [verSemana, setVerSemana] = useState(false); // modo Hoje: semana recolhida
  const [agoraHM, setAgoraHM] = useState(horaBrt());
  // Celular: cartões empilhados em vez da grade
  const [movel, setMovel] = useState(() => window.innerWidth <= 640);
  useEffect(() => {
    const f = () => setMovel(window.innerWidth <= 640);
    window.addEventListener('resize', f);
    return () => window.removeEventListener('resize', f);
  }, []);

  const hoje = hojeBrt();

  // ▶ Iniciar: followup/parceiros abrem a fila aqui; radar RESERVA a lista
  // pro closer (trava do dia — outro closer não puxa a mesma) e abre o SDR.
  async function iniciarBloco(b) {
    if (b.tipo === 'prospeccao' && b.fila_maps) {
      // Porta a porta: gera (ou reaproveita) a lista do território no Google
      try {
        const r = await apiJson('/closer/fila/pap/gerar', { method: 'POST', body: JSON.stringify({ territorio: b.fila_maps }) });
        navigate(`/sdr?lista=${encodeURIComponent(r.lista_id)}`);
      } catch (e) { window.alert(e.message); carregar(); }
      return;
    }
    if (b.tipo === 'radar' || (b.tipo === 'prospeccao' && b.fila_lista_busca)) {
      if (!b.fila?.lista_id) { navigate('/sdr'); return; }
      try {
        await apiJson('/closer/fila/rpi/puxar', { method: 'POST', body: JSON.stringify({ lista_id: b.fila.lista_id }) });
        navigate(`/sdr?lista=${encodeURIComponent(b.fila.lista_id)}`);
      } catch (e) {
        window.alert(e.message);
        carregar(); // outro closer puxou primeiro — atualiza a fila
      }
      return;
    }
    if (b.tipo === 'followup' || b.tipo === 'parceiros') { setModalTrabalho(b); return; }
    const t = tipoDe(b.tipo);
    if (t.link) navigate(t.link);
  }
  const temFila = (b) => ['followup', 'parceiros', 'radar'].includes(b.tipo) || (b.tipo === 'prospeccao' && (!!b.fila_lista_busca || !!b.fila_maps));
  const rotuloFila = (b) => {
    if (!b.fila) return '';
    if (b.fila.bloqueada_por) return `🔒 em trabalho com ${b.fila.bloqueada_por.split(' ')[0]}`;
    if (b.fila.pap && !b.fila.n) return '🗺️ ▶ gera a lista no Google';
    return `${b.fila.n} na fila${b.fila.minha ? ' · reservada pra você' : ''}`;
  };

  const carregar = useCallback(() => {
    apiJson(`/closer/semana?semana=${semana}${vagner && closerSel ? `&closer=${encodeURIComponent(closerSel)}` : ''}`)
      .then(d => {
        setDados(d);
        // Vagner: pré-seleciona o primeiro closer pra tela já abrir focada
        if (vagner && !closerSel && d.closers?.length) setCloserSel(d.closers[0]);
      })
      .catch(e => setDados({ erro: e.message }));
  }, [semana, closerSel, vagner]);

  useEffect(() => { carregar(); }, [carregar]);
  useEffect(() => { const t = setInterval(() => setAgoraHM(horaBrt()), 30000); return () => clearInterval(t); }, []);

  const blocos = dados?.blocos || [];
  const closers = dados?.closers || [];

  // Bloco de AGORA (janela atual) e o PRÓXIMO de hoje ainda pendente
  const doDia = blocos.filter(b => b.data === hoje && b.status === 'pendente');
  const blocoAgora = doDia.find(b => b.hora_ini <= agoraHM && agoraHM < b.hora_fim);
  const blocoProximo = !blocoAgora ? doDia.filter(b => b.hora_ini > agoraHM).sort((a, b) => a.hora_ini.localeCompare(b.hora_ini))[0] : null;
  const destaque = blocoAgora || blocoProximo;

  // Dias exibidos: seg–sex sempre; sáb/dom só se houver bloco
  const diasBase = [0, 1, 2, 3, 4].map(i => somarDias(semana, i));
  const extras = [5, 6].map(i => somarDias(semana, i)).filter(d => blocos.some(b => b.data === d));
  const dias = [...diasBase, ...extras];
  const porData = {};
  blocos.forEach(b => { (porData[b.data] = porData[b.data] || []).push(b); });

  // Contadores do resumo compacto (mesma régua do Analitics)
  const cont = { feitos: 0, nao_feitos: 0, vencidos: 0, pendentes: 0 };
  blocos.forEach(b => {
    const k = situacaoBloco(b, hoje, agoraHM).key;
    if (k === 'feito') cont.feitos++;
    else if (k === 'nao_feito') cont.nao_feitos++;
    else if (k === 'vencido') cont.vencidos++;
    else cont.pendentes++;
  });
  const pct = blocos.length ? Math.round(cont.feitos / blocos.length * 100) : 0;

  async function reabrir(b) {
    try { await apiJson(`/closer/bloco/${b._id}/reabrir`, { method: 'PUT' }); carregar(); } catch (e) { window.alert(e.message); }
  }
  async function excluirBloco(b) {
    if (!window.confirm(`Remover "${b.atividade}" de ${NOMES_DIA[b.dia_semana]}? (só desta semana — o padrão não muda)`)) return;
    try { await apiJson(`/closer/bloco/${b._id}`, { method: 'DELETE' }); carregar(); } catch (e) { window.alert(e.message); }
  }
  // Gerar/regerar/excluir sempre no ESCOPO do closer selecionado na aba —
  // antes valia pra todos de uma vez e a semana do Pedro "aparecia" pro Vagner
  async function regerar() {
    if (!window.confirm(`Regerar esta semana do padrão para ${closerSel || 'todos os closers'}? Os blocos atuais (inclusive desfechos já dados) serão substituídos.`)) return;
    try {
      await apiJson('/closer/semana/gerar', { method: 'POST', body: JSON.stringify({ semana, forcar: true, modelo: modeloGerar, closer: closerSel || '' }) });
      carregar();
    } catch (e) { window.alert(e.message); }
  }
  async function gerar() {
    try {
      await apiJson('/closer/semana/gerar', { method: 'POST', body: JSON.stringify({ semana, modelo: modeloGerar, closer: closerSel || '' }) });
      carregar();
    } catch (e) { window.alert(e.message); }
  }
  async function excluirSemana() {
    if (!window.confirm(`Excluir o planejamento da semana ${fmtCurto(semana)} – ${fmtCurto(somarDias(semana, 6))} de ${closerSel || 'TODOS os closers'}?\n\nApaga os blocos dele (inclusive desfechos já dados). A semana fica em branco — o automático de sexta NÃO recria; você recomeça pelo "Gerar semana do padrão" ou bloco a bloco.`)) return;
    try {
      await apiJson(`/closer/semana?semana=${encodeURIComponent(semana)}${closerSel ? `&closer=${encodeURIComponent(closerSel)}` : ''}`, { method: 'DELETE' });
      carregar();
    } catch (e) { window.alert(e.message); }
  }

  return (
    <div style={{ maxWidth: 960 }}>
      {modalRotina && <ModalRotina onFechar={() => { setModalRotina(false); carregar(); }} />}
      {modalConcluir && <ModalConcluir bloco={modalConcluir} onFechar={() => setModalConcluir(null)} onSalvo={() => { setModalConcluir(null); carregar(); }} />}
      {modalNao && <ModalNaoRealizado bloco={modalNao} onFechar={() => setModalNao(null)} onSalvo={() => { setModalNao(null); carregar(); }} />}
      {modalBloco && <ModalBloco bloco={modalBloco.bloco} semana={semana} closers={closers} closerPadrao={closerSel}
        onFechar={() => setModalBloco(null)} onSalvo={() => { setModalBloco(null); carregar(); }} />}
      {modalTrabalho && <ModalTrabalho bloco={modalTrabalho} aoAbrirCrm={() => navigate('/crm')}
        onFechar={() => { setModalTrabalho(null); carregar(); }} />}

      {/* Cabeçalho */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10, flexWrap: 'wrap', gap: 8 }}>
        <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628', margin: 0 }}>🧭 Closer — Minha Semana</h1>
        {vagner && (
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {infoModelos.modelos.length > 1 && (
              <select value={modeloGerar} onChange={e => setModeloGerar(e.target.value)}
                title="Modelo usado pelos botões Gerar/Regerar desta semana"
                style={{ padding: '3px 6px', borderRadius: 4, border: '1px solid #b0b8c4', fontSize: 12, fontWeight: 700, background: '#fff', height: 26 }}>
                <option value="">Modelo de cada closer</option>
                {infoModelos.modelos.map(m => <option key={m} value={m}>{m === infoModelos.ativo ? `★ ${m}` : m}</option>)}
              </select>
            )}
            <BtnCancel onClick={() => setModalRotina(true)}>✏️ Rotina padrão</BtnCancel>
            <BtnCancel onClick={() => setModalBloco({ bloco: null })}>➕ Bloco avulso</BtnCancel>
            {dados?.gerada || blocos.length
              ? <BtnCancel onClick={regerar} title="Substitui os blocos desta semana pelo padrão atual">↻ Regerar do padrão</BtnCancel>
              : <BtnPrimary onClick={gerar}>📅 Gerar semana do padrão</BtnPrimary>}
            {blocos.length > 0 && (
              <button onClick={excluirSemana} title="Apaga os blocos desta semana do closer selecionado — ela fica em branco pra recomeçar do zero"
                style={{ background: '#fff', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 4, padding: '3px 12px', fontWeight: 600, fontSize: 12, cursor: 'pointer' }}>
                🗑 Excluir semana
              </button>
            )}
          </div>
        )}
      </div>

      {/* Resumo compacto: navegação + closer + contadores */}
      <div style={{ background: '#fff', border: '1px solid #c8d0da', borderRadius: 4, padding: '6px 14px', marginBottom: 8, display: 'flex', gap: 14, fontSize: 13, flexWrap: 'wrap', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <button onClick={() => setSemana(s => somarDias(s, -7))} style={{ background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 3, padding: '1px 8px', cursor: 'pointer', fontSize: 13 }}>‹</button>
          <strong style={{ color: '#0a1628', minWidth: 128, textAlign: 'center', fontSize: 13 }}>Semana {fmtCurto(semana)} – {fmtCurto(somarDias(semana, 6))}</strong>
          <button onClick={() => setSemana(s => somarDias(s, 7))} style={{ background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 3, padding: '1px 8px', cursor: 'pointer', fontSize: 13 }}>›</button>
          {semana !== segundaDe(hoje) && (
            <button onClick={() => setSemana(segundaDe(hoje))} style={{ background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 3, padding: '1px 8px', cursor: 'pointer', fontSize: 12 }}>Hoje</button>
          )}
        </div>
        {vagner && closers.length > 1 && (
          <div style={{ display: 'flex', border: '1px solid #d1d5db', borderRadius: 3, overflow: 'hidden' }}>
            {closers.map(c => (
              <button key={c} onClick={() => setCloserSel(c)}
                style={{ padding: '2px 10px', fontSize: 12, fontWeight: closerSel === c ? 700 : 400, cursor: 'pointer', border: 'none', background: closerSel === c ? '#0a1628' : '#fff', color: closerSel === c ? '#fff' : '#374151' }}>
                {c.split(' ')[0]}
              </button>
            ))}
          </div>
        )}
        {blocos.length > 0 && (
          <>
            <span style={{ color: '#16a34a' }}>Feitos: <strong>{cont.feitos}</strong></span>
            <span style={{ color: '#dc2626' }}>Não feitos: <strong>{cont.nao_feitos}</strong></span>
            <span style={{ color: '#b45309' }}>Vencidos: <strong>{cont.vencidos}</strong></span>
            <span style={{ color: '#d97706' }}>Pendentes: <strong>{cont.pendentes}</strong></span>
            <span style={{ display: 'flex', alignItems: 'center', gap: 6, marginLeft: 'auto' }}>
              <span style={{ width: 90, height: 7, background: '#e5e7eb', borderRadius: 99, overflow: 'hidden', display: 'inline-block' }}>
                <span style={{ display: 'block', width: `${pct}%`, height: '100%', background: pct >= 80 ? '#16a34a' : pct >= 40 ? '#f59e0b' : '#dc2626', transition: 'width 0.3s' }} />
              </span>
              <strong style={{ color: '#0a1628', fontSize: 12, whiteSpace: 'nowrap' }}>{cont.feitos}/{blocos.length}</strong>
            </span>
          </>
        )}
      </div>

      {/* Modo HOJE: os blocos do dia em cartões grandes — a decisão já está tomada */}
      {semana === segundaDe(hoje) && blocos.some(b => b.data === hoje) && (
        <div style={{ marginBottom: 10 }}>
          <div style={{ background: '#dbeafe', borderLeft: '3px solid #1d4ed8', padding: '3px 10px', fontSize: 11, fontWeight: 700, color: '#1d4ed8', textTransform: 'uppercase', letterSpacing: '0.04em', borderRadius: '4px 4px 0 0' }}>
            📍 Hoje · {NOMES_DIA[diaSemanaDe(hoje)]} {fmtCurto(hoje)}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: movel ? '1fr' : 'repeat(auto-fill, minmax(215px, 1fr))', gap: 6, background: '#fff', border: '1px solid #c8d0da', borderTop: 'none', borderRadius: '0 0 4px 4px', padding: 8 }}>
            {(porData[hoje] || []).slice().sort((a, b) => a.hora_ini.localeCompare(b.hora_ini)).map(b => {
              const st = situacaoBloco(b, hoje, agoraHM);
              const agoraB = st.key === 'agora';
              const meu = vagner || b.closer === nomeUsuario;
              return (
                <div key={b._id} style={{
                  border: `1px solid ${agoraB ? '#93c5fd' : b.status === 'feito' ? '#bbf7d0' : '#e2e8f0'}`,
                  borderTop: `3px solid ${agoraB ? '#1d4ed8' : b.status === 'feito' ? '#16a34a' : st.key === 'vencido' ? '#b45309' : '#c8d0da'}`,
                  borderRadius: 4, padding: '6px 10px', background: agoraB ? '#eff6ff' : b.status !== 'pendente' ? '#f9fafb' : '#fff',
                  opacity: b.status === 'pendente' ? 1 : 0.75,
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                    <span style={{ fontSize: 12, fontWeight: 800, color: agoraB ? '#1d4ed8' : '#0a1628' }}>{agoraB ? '▶ AGORA · ' : ''}{b.hora_ini}–{b.hora_fim}</span>
                    <span style={{ background: st.bg, color: st.cor, padding: '0 6px', borderRadius: 3, fontSize: 10, fontWeight: 700 }}>{st.rotulo}</span>
                  </div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', marginBottom: 3, lineHeight: 1.3 }}>{tipoDe(b.tipo).icone} {b.atividade}</div>
                  {b.fila && b.status === 'pendente' && (
                    <div style={{ fontSize: 11.5, fontWeight: 700, color: b.fila.bloqueada_por ? '#6b7280' : b.fila.n ? '#b45309' : '#16a34a', marginBottom: 4 }}>
                      📋 {b.fila.bloqueada_por
                        ? rotuloFila(b)
                        : b.fila.n ? `${b.fila.n} na fila${b.fila.nome_lista ? ` · ${b.fila.nome_lista.replace('📡 ', '')}` : ''}${b.fila.minha ? ' · reservada pra você' : ''}` : (b.fila.pap ? '🗺️ ▶ gera a lista no Google' : 'fila zerada')}
                    </div>
                  )}
                  {b.status === 'pendente' && meu && (
                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                      {temFila(b) ? (
                        <button onClick={() => iniciarBloco(b)}
                          style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 3, padding: '3px 12px', fontSize: 11.5, fontWeight: 700, cursor: 'pointer' }}>
                          ▶ Iniciar
                        </button>
                      ) : tipoDe(b.tipo).link ? (
                        <button onClick={() => navigate(tipoDe(b.tipo).link)}
                          style={{ background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: 3, padding: '3px 10px', fontSize: 11.5, fontWeight: 600, cursor: 'pointer' }}>
                          {tipoDe(b.tipo).dica} →
                        </button>
                      ) : null}
                      <button onClick={() => setModalConcluir(b)}
                        style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 3, padding: '3px 10px', fontSize: 11.5, fontWeight: 700, cursor: 'pointer' }}>✓</button>
                      <button onClick={() => setModalNao(b)} title="Não realizado"
                        style={{ background: '#fff', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 3, padding: '3px 8px', fontSize: 11.5, fontWeight: 700, cursor: 'pointer' }}>✗</button>
                    </div>
                  )}
                  {b.status === 'feito' && b.resultado && <div style={{ fontSize: 11, color: '#15803d' }}>✓ {b.resultado}</div>}
                  {b.status === 'nao_feito' && b.motivo && <div style={{ fontSize: 11, color: '#b91c1c' }}>✗ {b.motivo}</div>}
                </div>
              );
            })}
            {(porData[hoje] || []).length === 0 && (
              <div style={{ fontSize: 12, color: '#9ca3af', padding: 8 }}>— dia livre —</div>
            )}
          </div>
        </div>
      )}

      {/* Semana completa: recolhida no modo Hoje (um clique expande) */}
      {semana === segundaDe(hoje) && !verSemana && blocos.length > 0 && (
        <button onClick={() => setVerSemana(true)}
          style={{ background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 4, padding: '4px 14px', fontSize: 12, fontWeight: 600, color: '#374151', cursor: 'pointer', marginBottom: 8 }}>
          📅 Ver a semana completa ▾
        </button>
      )}

      {/* Lista da semana (formato enxuto igual à Agenda) */}
      {!dados ? (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 4, padding: 20, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>Carregando…</div>
      ) : dados.erro ? (
        <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 4, padding: 20, textAlign: 'center', color: '#dc2626', fontSize: 13 }}>{dados.erro}</div>
      ) : blocos.length === 0 ? (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 4, padding: 20, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
          {vagner
            ? <>Nenhum bloco nesta semana. {closers.length === 0 ? 'Cadastre um usuário com cargo "closer" primeiro.' : <>Monte a <button onClick={() => setModalRotina(true)} style={{ background: 'none', border: 'none', color: '#1d4ed8', cursor: 'pointer', fontSize: 13, fontWeight: 700, padding: 0, textDecoration: 'underline' }}>rotina padrão</button> e clique em “Gerar semana do padrão”.</>}</>
            : 'Sua semana ainda não foi montada — o planejamento acontece toda sexta. Fale com o Vagner se precisar dela agora.'}
        </div>
      ) : (semana === segundaDe(hoje) && !verSemana) ? null : (
        <div style={{ border: '1px solid #c8d0da', borderRadius: 4, overflowX: 'auto' }}>
          {/* Cabeçalho tabela (no celular vira cartões empilhados) */}
          {!movel && (
            <div style={{ background: '#0a1628', display: 'grid', gridTemplateColumns: '110px 1fr 100px 170px', gap: 0, padding: '5px 10px', minWidth: 620 }}>
              {['Horário', 'Atividade', 'Situação', 'Ações'].map(h => (
                <span key={h} style={{ fontSize: 11, fontWeight: 700, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{h}</span>
              ))}
            </div>
          )}

          {dias.map(d => {
            const itens = (porData[d] || []).slice().sort((a, b) => a.hora_ini.localeCompare(b.hora_ini));
            const ehHoje = d === hoje;
            const larguraMin = movel ? 'auto' : 620;
            return (
              <React.Fragment key={d}>
                {/* Divisor do dia */}
                <div style={{ background: ehHoje ? '#dbeafe' : '#e8edf2', borderLeft: `3px solid ${ehHoje ? '#1d4ed8' : '#0a1628'}`, padding: '2px 10px', fontSize: 11, fontWeight: 700, color: ehHoje ? '#1d4ed8' : '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em', minWidth: larguraMin, boxSizing: 'border-box', display: 'flex', justifyContent: 'space-between' }}>
                  <span>{NOMES_DIA[diaSemanaDe(d)]} · {fmtCurto(d)}{ehHoje ? ' — hoje' : ''}</span>
                  <span style={{ fontWeight: 600, textTransform: 'none', letterSpacing: 0 }}>{itens.length ? `${itens.filter(b => b.status === 'feito').length}/${itens.length}` : ''}</span>
                </div>
                {itens.length === 0 ? (
                  <div style={{ padding: '4px 10px', fontSize: 12, color: '#c8d0da', minWidth: larguraMin, boxSizing: 'border-box' }}>— livre —</div>
                ) : itens.map((b, i) => {
                  const st = situacaoBloco(b, hoje, agoraHM);
                  const tipo = tipoDe(b.tipo);
                  const meu = vagner || b.closer === nomeUsuario;
                  const acoes = (
                    <div style={{ display: 'flex', gap: 4, alignItems: 'center', flexWrap: 'wrap' }}>
                      {b.status === 'pendente' && meu && temFila(b) && (
                        <button onClick={() => iniciarBloco(b)} title="Abrir a fila deste bloco"
                          style={{ background: '#0a1628', color: '#fff', padding: '2px 10px', borderRadius: 3, fontSize: 11, fontWeight: 700, border: 'none', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                          ▶ Iniciar
                        </button>
                      )}
                      {b.status === 'pendente' && meu && (
                        <>
                          <button onClick={() => setModalConcluir(b)}
                            style={{ background: '#16a34a', color: '#fff', padding: '2px 8px', borderRadius: 3, fontSize: 11, fontWeight: 600, border: 'none', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                            ✓ Feito
                          </button>
                          <button onClick={() => setModalNao(b)} title="Não realizado (com motivo)"
                            style={{ background: '#fff', color: '#dc2626', padding: '2px 7px', borderRadius: 3, fontSize: 11, fontWeight: 700, border: '1px solid #fecaca', cursor: 'pointer' }}>
                            ✗
                          </button>
                        </>
                      )}
                      {b.status !== 'pendente' && meu && (
                        <button onClick={() => reabrir(b)} title="Reabrir"
                          style={{ background: '#f3f4f6', color: '#374151', padding: '2px 8px', borderRadius: 3, fontSize: 11, border: '1px solid #d1d5db', cursor: 'pointer' }}>
                          ↩
                        </button>
                      )}
                      {tipo.link && b.status === 'pendente' && !temFila(b) && (
                        <button onClick={() => navigate(tipo.link)} title={tipo.dica}
                          style={{ background: '#eff6ff', color: '#1d4ed8', padding: '2px 8px', borderRadius: 3, fontSize: 11, border: 'none', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                          Abrir
                        </button>
                      )}
                      {vagner && (
                        <>
                          <button onClick={() => setModalBloco({ bloco: b })} title="Editar bloco"
                            style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 12, padding: '0 2px', marginLeft: 'auto' }}>✏️</button>
                          <button onClick={() => excluirBloco(b)} title="Remover só desta semana"
                            style={{ background: 'none', color: '#dc2626', border: 'none', cursor: 'pointer', fontSize: 14, fontWeight: 700, padding: '0 2px', lineHeight: 1 }}>✕</button>
                        </>
                      )}
                    </div>
                  );
                  const atividade = (
                    <div style={{ fontSize: 12, paddingRight: 8, minWidth: 0 }}>
                      <div style={{ color: '#111', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {tipo.icone} {b.atividade}{b.avulso ? <span title="Bloco avulso desta semana (fora do padrão)" style={{ color: '#9ca3af' }}> •</span> : ''}
                        {b.fila && b.status === 'pendente' && (
                          <span style={{ marginLeft: 6, background: b.fila.n ? '#fffbeb' : '#f0fdf4', color: b.fila.n ? '#b45309' : '#16a34a', border: `1px solid ${b.fila.n ? '#fde68a' : '#bbf7d0'}`, borderRadius: 8, padding: '0 6px', fontSize: 10, fontWeight: 700 }}>
                            📋 {rotuloFila(b) || 'fila zerada'}
                          </span>
                        )}
                      </div>
                      {b.status === 'feito' && b.resultado && <div style={{ fontSize: 11, color: '#15803d', marginTop: 1 }}>✓ {b.resultado}</div>}
                      {b.status === 'nao_feito' && b.motivo && <div style={{ fontSize: 11, color: '#b91c1c', marginTop: 1 }}>✗ {b.motivo}</div>}
                    </div>
                  );
                  if (movel) {
                    // Celular: cartão empilhado (sem rolagem horizontal)
                    return (
                      <div key={b._id} style={{ padding: '6px 10px', borderBottom: '1px solid #e8eaed', background: st.key === 'agora' ? '#eff6ff' : (i % 2 === 0 ? '#fafafa' : '#fff') }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                          <span style={{ fontSize: 12, fontWeight: 700, color: '#0a1628' }}>{b.hora_ini}–{b.hora_fim}</span>
                          <span style={{ background: st.bg, color: st.cor, padding: '1px 8px', borderRadius: 3, fontSize: 11, fontWeight: 700 }}>{st.rotulo}</span>
                        </div>
                        {atividade}
                        <div style={{ marginTop: 4 }}>{acoes}</div>
                      </div>
                    );
                  }
                  return (
                    <div key={b._id} style={{
                      display: 'grid', gridTemplateColumns: '110px 1fr 100px 170px',
                      alignItems: 'center', gap: 0, padding: '5px 10px', minWidth: 620, boxSizing: 'border-box',
                      borderBottom: '1px solid #e8eaed',
                      background: st.key === 'agora' ? '#eff6ff' : (i % 2 === 0 ? '#fafafa' : '#fff'),
                    }}>
                      <div style={{ fontSize: 12, fontWeight: 700, color: '#0a1628', whiteSpace: 'nowrap' }}>
                        {b.hora_ini}–{b.hora_fim}
                      </div>
                      {atividade}
                      <div>
                        <span style={{ background: st.bg, color: st.cor, padding: '1px 8px', borderRadius: 3, fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap' }}>
                          {st.rotulo}
                        </span>
                      </div>
                      {acoes}
                    </div>
                  );
                })}
              </React.Fragment>
            );
          })}
        </div>
      )}

      {semana === segundaDe(hoje) && verSemana && (
        <button onClick={() => setVerSemana(false)}
          style={{ background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 4, padding: '4px 14px', fontSize: 12, fontWeight: 600, color: '#374151', cursor: 'pointer', marginTop: 8 }}>
          Recolher a semana ▴
        </button>
      )}

      {blocos.some(b => b.avulso) && (
        <div style={{ fontSize: 10.5, color: '#9ca3af', marginTop: 6 }}>• = bloco avulso desta semana (não faz parte do padrão)</div>
      )}
    </div>
  );
}
